import {Injectable} from '@angular/core';
import {BaseDaoService, ChangesType, CustomField} from '@q9elements/ui-kit/common';

@Injectable({providedIn: 'root'})
export class CustomFieldsService extends BaseDaoService {
  getCustomFields(type: ChangesType) {
    return this.http.get<CustomField[]>(`${this.apiUrl}/customisations/fields/${type}`);
  }
}
